import { render, staticRenderFns } from "./ListLogos.vue?vue&type=template&id=022452f2&"
import script from "./ListLogos.vue?vue&type=script&lang=js&"
export * from "./ListLogos.vue?vue&type=script&lang=js&"
import style0 from "./ListLogos.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports